module.exports = __webpack_public_path__ + "img/app-icon-marketing.ec15ebd1.png";